// extracted by mini-css-extract-plugin
export var content = "_p0-1";
export var fullScreen = "_p0-0";